const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLafise(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 427.5 172",
    style: {
      enableBackground: "new 0 0 427.5 172"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M104.1,142.4c0,0,1.5,0.8,2.2,0.9c0.7,0.1,2,0.6,2,0.6l-0.5,0.3c0,0-1.2,0.1-2.3,0.1c-1,0-2.2-0.2-2.2-0.2 l-1.7-0.4l0.3-1l0.5-0.9l-1-0.2h-1.5l-0.6-0.1H7V18.2H1.9v123.3v4.8H7h131.4v-4.8h-35.2L104.1,142.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M103.2,131.6c-0.2,0.5,0,2.1-0.4,2.2c-0.4,0.1,0.6,1.6,0.6,1.6l-0.3,0.9h35.5v-4.8h-35.3 C103.2,131.5,103.2,131.6,103.2,131.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M13.4,43.3c0.1-0.2,0.8-0.9,1.1-1c0.2-0.1,0.6-0.7,1-1c0.5-0.2,0.6-0.7,0.6-0.7s-0.6-0.1-0.9,0.1 c-0.4,0.1-0.7,0.2-0.7,0.2s-0.3-0.3-0.3-0.6c-0.2-0.3-0.9-0.2-0.9-0.2L13,39.8c0,0,0.1-0.5,0.6-0.8s0-0.7-0.3-0.6 c-0.3,0.1-1,0.4-0.8,0.2c0.1,0,0-0.1,0-0.1v5.4l0.4-0.2C12.8,43.8,13.3,43.5,13.4,43.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M13.6,34.4c0.3-0.1,0.9-0.1,0.9-0.1l0.7-0.2c0,0,0.2-0.3,1-0.1v-0.6c0,0,0.7-0.9,0.9-1c0.2-0.2-0.5-0.6-0.5-0.6 l-1,0.3l-1.2,0.1l-0.7-0.3c0,0-0.1-0.4,0-0.6c0.1-0.2,0.7-0.6,0.7-0.6s0-0.4-0.1-0.6c0-0.2,0.4-0.7,0.4-0.7l0.6,0.2l0.3-0.5 c0.3-0.5,0.6-0.2,0.6-0.2l0.6,0.5l0.2,0.4l0.5-0.1v-2l0,0v-1.3c-0.2-0.1-0.5-0.1-0.5-0.1s-0.2-0.6,0.2-0.7c0.1-0.1,0.3-0.2,0.3-0.3 v-7.1h-5.1v17.4c0.1-0.1,0.1-0.2,0.2-0.3C13.1,35.1,13.3,34.5,13.6,34.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M17.6,136.3h78.5l0,0c-0.1-0.3-0.5-1.3-0.5-1.3s0.5-1.1,0-1.6c-0.4-0.4,0.2-1.7,0.2-1.7v-0.2H17.6V41.3 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.2-1,0.3-1.6,0.5s-1.1,1-1.6,1.4c-0.6,0.5-0.5,0.5-1.3,0.7c-0.1,0-0.2,0.1-0.3,0.1v87.2v4.8H17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M28.2,126.4h66c-0.2-0.5-0.5-1.1-0.5-1.3c0-0.3,0.1-1.5,0.4-1.9c0.1-0.2,0.2-0.9,0.2-1.7H28.2V40.2 c0-0.1-0.1-0.1-0.1-0.1s-1.9-0.8-2.2-1c-0.3-0.2-1.2-0.5-1.6-0.7c-0.3-0.3-0.5-0.3-1,0.1c-0.1,0-0.2,0.1-0.3,0.1v82.9v4.8h5.2V126.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M23.6,22.6c-0.3,0.1,0.3-0.3,0.7-0.6c0.4-0.2,0.6,0.3,0.6,0.3s0.6-0.3,0.9-0.4c0.2-0.1,0.3,0.3,0.3,0.3 c0.1,0,0.3,0.1,0.4,0.1c0.2,0.1,0.4,0.2,0.5,0.4c0.1,0.1,0,0.2,0,0.3c0,0.2,0.1,0.2,0.2,0.3c0.2,0.1,0.4,0.3,0.6,0.4 c0.1,0.1,0.2,0.1,0.3,0.2v-5.7h-5.2v4.6C23.3,22.8,24,22.5,23.6,22.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M138.2,121.5h-30.4c0,0.1,0.1,0.1,0.1,0.2c0.3,0.3,0.9,0.6,1,1.1c0.2,0.5,0.2,0.8-0.3,1.4 c-0.5,0.5-2.2,0.9-2.9,1.1c-0.5,0.1-0.7,0.7-0.8,1.1h33.2v-4.9H138.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M34.9,26.9L34.9,26.9c0.1,0.1,0.5,0.2,0.6,0.2c0,0,0.1,0,0.1,0.1h-0.1c0.1,0.1,0.1,0.3,0.2,0.4 c0.1,0.1,0.4,0.1,0.5,0.2c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.2-0.3,0.2-0.5c0-0.1,0.1-0.2,0.1-0.3 s0-0.1,0.2-0.1c0.4,0,0.6,0.4,0.9,0.2c0.1-0.1,0.2-0.1,0.4-0.2c0.1,0,0.3-0.1,0.4-0.1v-7.9h-5.2v7.9c0.2,0.2,0.4,0.3,0.6,0.4 C34.5,26.7,34.7,26.8,34.9,26.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M138.4,111.6h-21c-0.4,0.2-0.7,0.5-0.8,0.6c-0.3,0.3-0.3,1.3-0.3,1.7c0,0.4,0.1,1.4,0.1,1.4s-0.1,0.6-0.3,1.2 h22.3L138.4,111.6L138.4,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M37.9,27.9c0.3,0,0.6,0,0.8-0.2c0.1,0,0.1,0,0.2-0.1V27c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.1-0.3,0.1-0.5,0.1 C37.8,27.5,37.5,27.9,37.9,27.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M38.8,116.4h54.8c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.7,0-1.4,0.2-2.2c0.1-0.3,0.1-1,0-1.7H38.8V65.8 c-0.2-0.4-0.5-0.6-0.5-0.6l-0.6-0.4c0,0-0.8-0.5-1-0.7s-0.8-0.8-1-1c-0.1-0.3-0.1-1.1-0.1-1.1s-0.6-0.6-0.7-0.8 c-0.1-0.2-0.6-0.8-0.6-1.1c0-0.3,0-0.9,0-0.9s0-1-0.1-1.3c0-0.3,0.1-0.7,0.2-1.1c0.1-0.4,0.4-2.5,0.8-2.8c0.4-0.4,0.5-0.9,0.5-0.9 l0.4-0.6c0,0-0.1-1-0.3-1.2c-0.3-0.3-1-1.4-1.3-1.6s-0.6-1.3-0.8-1.9v63.6v4.8h5.1V116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M44.4,71.6l2,3.3V76l-2.1-1.8v27.4v4.9h5.1h43.8c-0.1-0.8-1.4-1.1-2.1-1.4c-0.6-0.3-2.3-0.6-2.8-1.2 c-0.6-0.5-1.8-1.7-2-2.2c0,0,0,0-0.1-0.1H49.5V74.8l-1.2-0.5L47.7,74l0.1-0.5v-0.6c0,0-0.7-0.6-0.9-0.8c-0.1-0.2-1.1-1-1.1-1 s-0.8-0.5-0.9-0.7c-0.1-0.2-0.2-0.6-0.3-0.8c0-0.1-0.1-0.1-0.1-0.2v2C44.4,71.4,44.5,71.5,44.4,71.6L44.4,71.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M45.2,27.7c0.1,0.1,0,0.1,0.1,0.2c0.1,0.2,0.6,0.3,0.8,0.3c0.1,0,0.2,0,0.3,0s0.2-0.1,0.3-0.1s0.1,0.1,0.2,0.1 c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0,0-0.1,0-0.1-0.1c0.1,0,0.1,0.1,0.2,0.1c0-0.1-0.1-0.1-0.1-0.1 c0.2,0.2,0.3,0.4,0.7,0.3c0.1,0,0.1-0.1,0.3-0.2c0.2-0.1,0.1,0,0.2,0.1c0.1,0.1,0.3,0.2,0.2,0.3s-0.2,0.1-0.3,0.2 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.1-0.3,0.1-0.5,0.2c0,0.2,0,0.3,0.2,0.4c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0.1,0.1,0.1 c0.1,0.1,0.1,0.1,0.3,0.1s0.2,0.1,0.3,0.2c0.2,0.1,0.6,0,0.8-0.1c0.1,0,0.1,0,0.1,0V18.3h-5.1v9c0.1,0,0.1,0,0.3,0 C44.8,27.4,45.1,27.4,45.2,27.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M138.5,101.6h-13.1v0.1c0,0,0,2.2-0.4,3.1c-0.2,0.4-0.4,1-0.7,1.7h14.2V101.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M138.2,96.5v-4.8H118l1.9,0.7l2.6,0.3c0,0,1.5,0.3,2,0.4s1.1,1,1.4,1.4s1.6,0.3,2,0.5s1,1.2,1,1.2 s0,0.1-0.1,0.3H138.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M60.1,96.5h22.2c-0.4-0.4-0.7-0.7-0.8-0.9c-0.3-0.5-0.6-1.3-0.9-1.6c-0.3-0.3-0.1-1.5-0.1-1.5v-0.9H60.1V79.4 h-0.7L57,79.1c0,0-0.7-1.8-1.2-2.1c-0.3-0.2-0.6-0.3-0.9-0.4v15.2v4.8L60.1,96.5L60.1,96.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M59.1,43.1c0.3,0,0.4,0,0.7,0.1c0.1,0,0.2,0.1,0.3,0.1V37L60,37.1c-0.5,0.4-0.9,0.8-1.3,1.3c0,0,0,0,0-0.1 c-0.2-0.1-0.2,0.2-0.3,0.3c-0.2,0.3-0.5,0.5-0.7,0.8c-0.1,0.3-0.1,0.5-0.3,0.8c-0.1,0.2-0.2,0.4-0.1,0.7c0,0.1,0.1,0.3,0.3,0.3 c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0.1c0.2,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0,0.4,0.1,0.4 c0,0.1-0.1,0.1-0.1,0.1c0.2,0.2,0.1,0.4,0,0.6C58.6,43,58.8,43,59.1,43.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M55.2,30.5L55.2,30.5c0.1-0.1,0.2-0.1,0.3,0c0.4,0.1,0.7,0.2,1.1,0.4c0.1,0,0.3,0.1,0.4,0.1 c0.3,0.1,0.5,0.2,0.8,0.1c0.3-0.1,0.4-0.4,0.6-0.6c0.2-0.1,0.4-0.4,0.6-0.4c0,0.1,0,0.1-0.1,0.2c-0.1,0.2-0.1,0.4-0.3,0.5h0.1 c-0.1,0.1-0.1,0.1,0,0.2c0.3-0.2,0.4,0.2,0.3,0.4c-0.1,0.2-0.5,0.4-0.3,0.6c-0.2,0.1,0.1,0.3,0.2,0.2c0.3,0,0.5-0.3,0.6-0.5 s0.3-0.4,0.4-0.6c0-0.1,0.1-0.1,0.1-0.2V18.3h-5.2v12.3h0.1C55,30.5,55.1,30.5,55.2,30.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M56.5,74.1l0.6,1.1l1.4-1.3c0,0,0.6-1.1,0.8-1.6c0.1-0.3,0.5-0.6,0.8-0.8v-6.4l-0.5,0.1c0,0-0.5,0.2-0.6,0.3 c-0.1,0.2-0.1,0.2-0.3,0.3c-0.3,0.3-0.4,0.3-0.4,0.3L57.6,66l-1.1-0.2l-0.4,0.3c0,0,0.1-0.1-1.2,0.6v7.1c0.3,0.3,0.7,0.5,0.8,0.5 C56.1,74.4,56.5,74.1,56.5,74.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M99.2,82.6l1.4,0.2l1.5,0.9l1.5,1l1.7,0.1h0.9l2.2,0.7c0,0,1.6,0.7,2.2,1.2c0,0,0,0,0,0.1h27.6v-4.9H98.9 c0.2,0.1,0.4,0.1,0.5,0.2C100.6,82.5,99.2,82.6,99.2,82.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M70.7,86.6h10.8c0.2-1-2.5-1.3-2.6-1.6c0,0-0.9-0.1-1.1-0.4s-1.5-1.2-1.5-1.2c-0.6-0.2-2.8,0.3-2.8,0.3L73,84.3 c0,0-1.2-0.1-1.7-0.2c-0.4-0.1-1-0.5-1-0.5h-1.4l-0.7-0.4l-1.3-0.1l-1-0.3l-0.2-1l-0.2-0.1l0,0v4.9H70.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M90.1,82.2c0.4,0,0.7-0.4,0.7-0.4s0.1-0.1,0.2-0.1h-1.7l0.1,0.2C89.4,81.9,89.7,82.3,90.1,82.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M77.3,82.1l0.8,0.2l0,0l0.9,0.6h0.8c0,0,1.4-0.7,2.5-1.2h-5.6L77.3,82.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M67,76.8c0,0,0.6,0.1,1,0.1s0.1,0.5,0.1,0.5l0.1,1.2c0,0,0,0.5,0.1,0.9s-0.2,1.4-0.2,1.4s0.3,0.2,0.6,0.5 c0.3,0.4,0.6,0.5,1.3,0.7c0.7,0.3,1,0.5,1,0.5s1.3,0,1.6,0c0.3-0.1,1-0.7,1-0.7l1.3-0.2h-4.1V56.2c-0.1,0.1-0.2,0.1-0.2,0.1 c-0.2,0.1-0.6,0.3-0.7,0.4c-0.2,0.1-0.3,0.3-0.3,0.4c-0.1,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.4,0.1-0.6,0.2s-0.3,0.4-0.3,0.6 s-0.1,0.5-0.2,0.5c0,0.1,0.2,0.4,0.3,0.6c0,0.2,0.1,0.3,0.1,0.3s-0.4,0.9-0.5,1S67.3,61,67.3,61s-0.7,0.8-1,0.9 c-0.1,0.1-0.5,0.5-0.8,0.8v13.9l0.4-0.2L67,76.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M65.7,48.4c0,0.1,0,0.1,0.2,0.1c0.2-0.1,0.4-0.1,0.6-0.2c0.3-0.2,0.5-0.5,0.7-0.7c0.3-0.2,0.9-0.6,0.6-1 c-0.1-0.1-0.3-0.2-0.3-0.5c0-0.1,0-0.3-0.1-0.4c-0.2-0.2-0.5-0.3-0.6-0.6c0-0.1,0-0.1,0.1-0.3s0.3-0.3,0.5-0.4 c0.1-0.1,0.2-0.1,0.3-0.2c0,0,0,0,0-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.3,0.3-0.4 c0.3-0.3,0.6-0.8,0.3-1.2c-0.1-0.2-0.2-0.4-0.4-0.5c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1-0.1,0.1-0.2,0.1-0.4c-0.1-0.1-0.3-0.1-0.3-0.2 c0-0.1,0.3-0.3,0.4-0.4c0-0.1,0-0.3,0.2-0.4c0,0,0.1-0.1,0.2-0.2c0.1-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3s-0.1-0.2-0.2-0.2 c-0.2-0.2-0.4-0.4-0.2-0.6c0.1-0.2,0.3-0.5,0.5-0.7c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.1,0.1-0.3c0.1-0.2,0.4-0.1,0.5-0.1 s0.2,0,0.3,0.1c0,0.1,0,0.1,0.1,0.2c0,0,0,0,0.1,0V18.3h-5.2v12.8c0.1,0,0.1-0.1,0.2-0.1c0.2-0.2,0.3-0.5,0.4-0.7s0.1-0.5,0.2-0.7 c0-0.1,0.2-0.3,0.3-0.3c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.2,0-0.2-0.2-0.3c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.3,0.3-0.2 c0.1,0,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0,0.3,0.1c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.1,0.5,0.1,0.5,0.3s-0.2,0.3-0.3,0.4 c0.1,0,0.1,0.2-0.1,0.4c-0.1,0.1-0.3,0.2-0.3,0.3l0.2,0.2c0.1,0.1,0.3,0.1,0.3,0.2c0.1,0.1-0.1,0.3-0.1,0.3 c-0.1,0.2-0.2,0.3-0.4,0.4c-0.2,0.2-0.2,0.5-0.4,0.6c-0.2,0.1-0.5,0-0.6-0.1c-0.1,0-0.1-0.1-0.1-0.1c-0.3-0.1-0.4,0.2-0.7,0.2 c-0.1,0-0.2,0-0.2,0v16c0,0,0.1,0,0.1,0.1C65.7,48.2,65.7,48.4,65.7,48.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M81.3,76.6h57.2v-4.8H81.3V46.3c-0.2,0.2-0.3,0.3-0.4,0.4c-0.2,0.2-0.9,0.7-1.7,0.9c-0.8,0.2-1.9,0.2-1.9,0.2 s-0.6,0.1-1.2,0.3v3h0.1c0.3,0.1,0.6,0.3,0.7,0.5c0.1,0.1,0.3,0.4,0.5,0.5s0.8-0.4,0.8-0.4l0.4-0.3l0.1,0.3c0,0,0,0.1-0.2,0.2 s-0.2,0.2-0.5,0.5c-0.3,0.2-0.5,0.4-0.8,0.5C77,53,76.5,53,76.3,53.1c0,0-0.1,0-0.2,0v18.7v4.8H81.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M77.2,39.2l0.6-0.1c0,0,0.1,0.3,0.1,0.6c-0.1,0.3,0,0.9,0.1,1s0.2,0.2,0.3,0.2c0.2,0,0.4,0.3,0.7,0.5 c0.3,0.1,0.4,0.3,0.4,0.5s-0.2,0.3-0.3,0.8c-0.1,0.4,0.6,0.4,0.8,0.5c0.2,0.1,1.2,0.2,1.3,0.3c0,0,0.2,0.3,0.1,0.4V18.2h-5.1v22.6 c0.1-0.2,0.5-1,0.6-1.1C76.8,39.6,77.2,39.2,77.2,39.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M79.5,46.5l0.1-0.3c0-0.1,0-0.2,0.2-0.4c0.1-0.2,0.4-0.1,0.7-0.1c0.2,0,0.5-0.2,0.8-0.3V44c0,0,0,0.1-0.1,0.1 c-0.2,0.1-0.2,0.5-0.6,0.7c-0.3,0.2-1,0.3-1.2,0.5s0.1,0.4,0.2,0.5c0,0.1-0.1,0.2-0.3,0.4C79.1,46.4,79.5,46.5,79.5,46.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    points: "91.9,61.8 91.9,18.2 86.7,18.2 86.7,61.8 86.7,66.6 91.9,66.6 138.6,66.6 138.6,61.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    points: "102.5,56.7 138.3,56.7 138.3,51.8 102.5,51.8 102.5,18.2 97.3,18.2 97.3,51.8 97.3,56.7 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    points: "113.1,46.8 138.5,46.8 138.5,41.9 113.1,41.9 113.1,18.2 108,18.2 108,41.9 108,46.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    points: "123.7,36.8 138.6,36.8 138.6,32 123.7,32 123.7,18.2 118.5,18.2 118.5,32 118.5,36.8 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    points: "134.3,26.8 138.3,26.8 138.3,22 134.3,22 134.3,18.3 129.1,18.3 129.1,22 129.1,26.8 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M60.1,36.4v0.5c0.1-0.1,0.2-0.2,0.2-0.3C60.2,36.6,60.1,36.5,60.1,36.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    points: "153.4,81.6 165.4,81.6 165.4,135.5 195,135.5 195,146.4 153.4,146.4 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M219.4,120.8l8-24.1l8.2,24.1H219.4z M257.6,146.4l-23.7-64.8h-12.6l-23.1,64.8h12.7l4.9-14.7h23.7l5.1,14.7 H257.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    points: "261.7,81.6 302.3,81.6 302.3,92.5 273.6,92.5 273.6,107.9 298.4,107.9 298.4,118.8 273.6,118.8  273.6,146.4 261.7,146.4 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 81.6,
    className: "st0",
    style: {
      fill: "#005739"
    },
    width: 11.9,
    height: 64.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M337.4,124.1c0.5,3.4,2.1,12.4,12.9,12.4c8.3,0,11.6-4.8,11.6-8.9c0-5.5-4.2-6.6-15-9.5 c-5.9-1.6-18.9-5.2-18.9-19.4c0-7.1,4.2-18.1,21.5-18.1c11.5,0,22.1,4.9,22.6,19.6l-12,0.6c-0.5-3.4-1.4-9.4-10.8-9.4 c-3.6,0-10,1.2-10,6.4c0,4.2,3.7,6,13.2,8.4c9,2.4,21.3,5.6,21.3,21.5c0,7.9-4.5,14.4-9.7,17c-5.3,2.7-11.2,2.9-13.9,2.9 c-6.4,0-22.1-0.6-24.4-22.2L337.4,124.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    points: "378.9,81.6 422.8,81.6 422.8,92.5 390.9,92.5 390.9,106.9 420.6,106.9 420.6,117.9 390.9,117.9  390.9,135.5 423.9,135.5 423.9,146.4 378.9,146.4 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.9,
    y: 153.1,
    className: "st0",
    style: {
      fill: "#005739"
    },
    width: 423.8,
    height: 3.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M148.2,60.9l5.6-0.5c0.3,1.9,1,3.2,2,4.1s2.4,1.3,4.1,1.3c1.8,0,3.2-0.4,4.2-1.2c0.9-0.8,1.4-1.7,1.4-2.7 c0-0.7-0.2-1.2-0.6-1.7c-0.4-0.5-1.1-0.9-2.1-1.2c-0.7-0.2-2.2-0.6-4.6-1.2c-3.1-0.8-5.2-1.7-6.5-2.8c-1.7-1.6-2.6-3.5-2.6-5.7 c0-1.4,0.4-2.8,1.2-4.1s2-2.2,3.5-2.9s3.4-1,5.6-1c3.6,0,6.2,0.8,8,2.3c1.8,1.6,2.7,3.6,2.8,6.2l-5.7,0.3c-0.2-1.5-0.8-2.5-1.6-3.1 s-2-1-3.6-1c-1.7,0-3,0.3-3.9,1c-0.6,0.4-0.9,1-0.9,1.8c0,0.7,0.3,1.2,0.9,1.7c0.7,0.6,2.5,1.2,5.3,1.9c2.8,0.7,4.8,1.3,6.2,2 s2.4,1.7,3.1,2.9c0.8,1.2,1.1,2.7,1.1,4.5c0,1.6-0.5,3.1-1.4,4.6c-0.9,1.4-2.2,2.5-3.8,3.2c-1.7,0.7-3.7,1-6.2,1 c-3.6,0-6.3-0.8-8.3-2.5C149.7,66.5,148.5,64.1,148.2,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M176,70.2V41.8h21v4.8h-15.3v6.3H196v4.8h-14.2v7.7h15.8v4.8C197.6,70.2,176,70.2,176,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M215.7,59.7v-4.8H228v11.3c-1.2,1.2-2.9,2.2-5.2,3.1s-4.6,1.3-6.9,1.3c-3,0-5.6-0.6-7.8-1.9 c-2.2-1.2-3.9-3-5-5.3s-1.7-4.8-1.7-7.6c0-3,0.6-5.6,1.9-7.9c1.2-2.3,3-4.1,5.4-5.3c1.8-0.9,4.1-1.4,6.8-1.4c3.5,0,6.3,0.7,8.3,2.2 s3.3,3.5,3.8,6.1l-5.7,1.1c-0.4-1.4-1.2-2.5-2.3-3.3s-2.5-1.2-4.1-1.2c-2.5,0-4.5,0.8-6,2.4c-1.5,1.6-2.2,3.9-2.2,7.1 c0,3.4,0.7,5.9,2.2,7.6s3.5,2.5,5.9,2.5c1.2,0,2.4-0.2,3.6-0.7c1.2-0.5,2.2-1,3.1-1.7v-3.6H215.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M233.2,41.8h5.7v15.4c0,2.4,0.1,4,0.2,4.7c0.2,1.2,0.8,2.1,1.8,2.8s2.2,1.1,3.8,1.1s2.9-0.3,3.7-1 s1.3-1.5,1.5-2.4c0.2-1,0.3-2.6,0.3-4.8V41.8h5.7v14.9c0,3.4-0.2,5.8-0.5,7.2s-0.9,2.6-1.7,3.6s-1.9,1.7-3.3,2.3 c-1.4,0.6-3.2,0.9-5.5,0.9c-2.7,0-4.8-0.3-6.2-0.9s-2.5-1.4-3.3-2.4s-1.3-2-1.6-3.1c-0.4-1.6-0.6-4-0.6-7.2L233.2,41.8L233.2,41.8z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M261.9,70.2V41.8H274c3,0,5.2,0.3,6.6,0.8s2.5,1.4,3.3,2.7s1.2,2.8,1.2,4.5c0,2.1-0.6,3.9-1.9,5.3 s-3.1,2.3-5.6,2.6c1.2,0.7,2.3,1.5,3.1,2.4c0.8,0.9,1.9,2.4,3.3,4.6l3.5,5.5h-6.8l-4.1-6.2c-1.5-2.2-2.5-3.6-3-4.2s-1.1-1-1.7-1.2 s-1.6-0.3-2.9-0.3h-1.2v11.8L261.9,70.2L261.9,70.2z M267.6,53.8h4.2c2.7,0,4.5-0.1,5.1-0.3c0.7-0.2,1.2-0.6,1.6-1.2 s0.6-1.3,0.6-2.1c0-1-0.3-1.7-0.8-2.3s-1.2-1-2.2-1.1c-0.5-0.1-1.9-0.1-4.2-0.1h-4.5v7.1H267.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M289.3,56.1c0-2.9,0.4-5.3,1.3-7.3c0.6-1.4,1.5-2.7,2.6-3.9c1.1-1.1,2.3-2,3.7-2.6c1.8-0.7,3.8-1.1,6.1-1.1 c4.2,0,7.5,1.3,10,3.9c2.5,2.6,3.8,6.2,3.8,10.8s-1.2,8.2-3.7,10.7c-2.5,2.6-5.8,3.9-10,3.9s-7.6-1.3-10.1-3.9 S289.3,60.7,289.3,56.1z M295.2,56c0,3.2,0.7,5.6,2.2,7.3s3.4,2.5,5.6,2.5s4.2-0.8,5.6-2.5s2.2-4.1,2.2-7.4s-0.7-5.7-2.1-7.3 c-1.4-1.6-3.3-2.4-5.7-2.4s-4.3,0.8-5.7,2.4C296,50.2,295.2,52.7,295.2,56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    style: {
      fill: "#005739"
    },
    d: "M319.9,60.9l5.6-0.5c0.3,1.9,1,3.2,2,4.1s2.4,1.3,4.1,1.3c1.8,0,3.2-0.4,4.2-1.2c0.9-0.8,1.4-1.7,1.4-2.7 c0-0.7-0.2-1.2-0.6-1.7s-1.1-0.9-2.1-1.2c-0.7-0.2-2.2-0.6-4.6-1.2c-3.1-0.8-5.2-1.7-6.5-2.8c-1.7-1.6-2.6-3.5-2.6-5.7 c0-1.4,0.4-2.8,1.2-4.1c0.8-1.3,2-2.2,3.5-2.9s3.4-1,5.6-1c3.6,0,6.2,0.8,8,2.3c1.8,1.6,2.7,3.6,2.8,6.2l-5.7,0.3 c-0.2-1.5-0.8-2.5-1.6-3.1c-0.8-0.6-2-1-3.6-1c-1.7,0-3,0.3-3.9,1c-0.6,0.4-0.9,1-0.9,1.8c0,0.7,0.3,1.2,0.9,1.7 c0.7,0.6,2.5,1.2,5.3,1.9c2.8,0.7,4.8,1.3,6.2,2s2.4,1.7,3.1,2.9c0.8,1.2,1.1,2.7,1.1,4.5c0,1.6-0.5,3.1-1.4,4.6 c-0.9,1.4-2.2,2.5-3.8,3.2c-1.7,0.7-3.7,1-6.2,1c-3.6,0-6.3-0.8-8.3-2.5S320.2,64.1,319.9,60.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLafise);
export default __webpack_public_path__ + "static/media/Lafise.4ed4a660097d7476155c065c47a56e51.svg";
export { ForwardRef as ReactComponent };